import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import ClassicRanking from './components/ClassicRanking';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '欧美大片推荐',
    url: 'https://www.oumeidapian.com/',
    description: '欧美大片精选推荐，涵盖好莱坞动作、科幻、悬疑、爱情等热门类型，提供高清在线观看指南与最新上映资讯。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.oumeidapian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '欧美大片推荐',
    url: 'https://www.oumeidapian.com/',
    description: '致力于为广大影迷提供最新、最全的欧美大片推荐与观影指南。',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedMovies />
        <CategoryNav />
        <LatestArticles />
        <ClassicRanking />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}